import { Col, Form, Row } from 'antd'
import CustomSpin from '../../../../../../elements/CustomSpin'
import FormSectionTitle from '../../../../../../elements/FormSectionTitle'
import useFetchSelectUrl from '../../../../../../elements/Hooks/useFetchSelectUrl'
import { rules, threeFormItemLayout } from '../../../../../../modules/FormItems'
import React from 'react'


function SalesContribForm(props) {
  const { submitting } = props
  const { getFieldDecorator } = props.form

  const [SalesSelect] = useFetchSelectUrl(
    {
      name: 'clients_sales',
      url: `sales/?select=_id,code,title`,
      cache: true,
    },
    undefined,
    undefined,
    undefined,
    c => ({ ...c, display: `[${c.code}]  ${c.title}` }),
  )

  return (
    <CustomSpin spinning={submitting}>
      <Form>
        <FormSectionTitle title={'Details'} />
        <Row>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'Sales Order'}>
              {getFieldDecorator('_id', {
                rules: rules.select,
              })(<SalesSelect keyAtr={'_id'} valueAtr={'display'} />)}
            </Form.Item>
          </Col>

          {/*<Col span={8}>*/}
          {/*  <Form.Item {...threeFormItemLayout} label={'Start'}>*/}
          {/*    {getFieldDecorator('start', {*/}
          {/*      initialValue: moment('01-01-2015'),*/}
          {/*      rules: rules.date,*/}
          {/*    })(<DatePicker style={{width: '100%'}} placeholder="Start" />)}*/}
          {/*  </Form.Item>*/}
          {/*</Col>*/}
          {/*<Col span={8}>*/}
          {/*  <Form.Item {...threeFormItemLayout} label={'End'}>*/}
          {/*    {getFieldDecorator('end', {*/}
          {/*      initialValue: moment(),*/}
          {/*      rules: rules.date,*/}
          {/*    })(<DatePicker style={{width: '100%'}} placeholder="End" />)}*/}
          {/*  </Form.Item>*/}
          {/*</Col>*/}
        </Row>
      </Form>
    </CustomSpin>
  )
}

SalesContribForm.propTypes = {}
SalesContribForm.defaultProps = {
  selection: [],
}

export default Form.create()((SalesContribForm))
